import ajax from '../ajax'



//api/image/sign 获取签名
//post
//参数 filename

///api/image/finish 上传完回调请求
//参数 image_id

export function SignApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/sign',
        data
    })
}


///api/image/exists
export function ExistsApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/exists',
        data
    })
}



//上传完的回调
export function completeUploadApi(params) {
    return ajax({
        method:'get',
        url: '/api/image/finish',
        params
    })
}

//开始上传
export function startUploadApi(url,FormData) {
    return ajax({
        method:'post',
        url: url,
        data:FormData
    })
}









//api/image/del
export function DelApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/del',
        data
    })
}





// 权限管理  /api/user/status
export function StatusApi(params) {
    return ajax({
        method:'get',
        url: '/api/user/status',
        params
    })
}

/////api/image/scorelist 图片列表
export function indexApi(params) {
    return ajax({
        method:'get',
        url: '/api/image/scorelist',
        params
    })
}
/////api/image/scorelist 评分
export function ScoreApi(params) {
    return ajax({
        method:'get',
        url: '/api/image/score',
        params
    })
}

///api/image/scoreinfo?id=1  大图的
export function Scoreinfo(params) {
    return ajax({
        method:'get',
        url: '/api/image/scoreinfo',
        params
    })
}


///api/image/submit 普通人的提交评分
export function Submitinfo(params) {
    return ajax({
        method:'get',
        url: '/api/image/submit',
        params
    })
}


///api/image/clear  交卷
export function Clearinfo(params) {
    return ajax({
        method:'get',
        url: '/api/image/clear',
        params
    })
}

///api/image/search
export function SearchApi(params) {
    return ajax({
        method:'get',
        url: '/api/image/search',
        params
    })
}

//退出评图
export function EditApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/edit',
        data
    })
}


//api/image/staffscore

export function StaffscoreApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/staffscore',
        data
    })
}


///api/image/status

export function ImgStatusApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/status',
        data
    })
}


// /api/image/back
// 评图列表全部清空

export function backApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/back',
        data
    })
}


// 获取排序方式/api/image/getorder
export function getorderApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/getorder',
        data
    })
}


// /api/image/staff
// post 设置图片制作人员
// id 图片id
// staff_id 制作人id
export function StaffApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/staff',
        data
    })
}


///api/image/getstaff  获取制作人

export function GetstaffApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/getstaff',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/design_comment/index.js